<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px">
      <b-col cols="12" md="9">
        <b-row class="mb-5"
               v-for="item in dataDonations"
               :key="item.id"
        >
          <b-col cols="12" xl="8">
            <div class="donation-list-item">
              <b-carousel
                :id="`carousel-${item.id}`"
                :interval="4000"
                fade
                controls
                background="#ababab"
                img-width="100%"
                img-height="auto"
              >
                <b-carousel-slide class="custom-image-slider" v-for="(image, index) in item.images" :img-src="image" :key="index"></b-carousel-slide>
              </b-carousel>
              <h2 class="mt-4 text-left">{{item.name}}</h2>
              <p class="text-left">{{item.description}}</p>

            </div>
          </b-col>
          <b-col cols="12" xl="4">
            <div class="box-total-donation d-flex flex-column">
              <h3 class="mb-4">Donate to {{item.name}}</h3>
              <h2 class="donation-dollar mb-1">$ {{formatPrice(item.total_donation)}}</h2>
              <span class="d-inline-block text-left mb-4">Total Donations</span>
              <a :href="`/#/donations?_d=${item.id}`" class="btn btn-primary" v-if="!item.is_donate">Donate Now</a>
              <div class="d-flex flex-column text-left" v-if="item.is_donate">
                <h4 class="is-donate">You donated to this mission</h4>
                <span class="d-inline-block mb-1 text-muted">Next Donation {{item.next_donation}}</span>
                <a @click="cancelDonation(item.id)" class="cursor-pointer text-muted"  >Cancel Donation</a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins'
import moment from "moment";
export default {
  name: "DonationLists",
  mixins:[helperMixins],
  data() {
    return {
      utc_offset:Math.floor(moment().utcOffset()/60),
      dataDonations:[

      ]
    }
  },
  computed:{
    ...mapGetters('DonationsModule', ['listOnGoingList']),
  },
  watch:{
    listOnGoingList: {
      immediate: true,
      deep: true,
      async handler(val) {
        if(val.data !== undefined){
          this.dataDonations = val.data.map((donat)=>{
            let next_date = '';
            if(donat.subscribed){
              if(this.utc_offset<0){
                next_date = moment(donat.metadata.next_donation_period).subtract(Math.abs(this.utc_offset),"hour")
              }else{
                next_date = moment(donat.metadata.next_donation_period).add(this.utc_offset,"hour")
              }
              next_date = next_date.format('DD MMM YYYY');
            }
            return {
              id:donat.id,
              name:donat.organization,
              images:donat.banner,
              description:donat.description,
              total_donation:parseFloat(donat.total_donation).toFixed(2),
              is_donate:donat.subscribed,
              next_donation: next_date
            };
          });
        }
      }
    },
  },
  async mounted() {
    await this.requestOnGoingList();
  },
  methods:{
    ...mapActions('DonationsModule', ['requestOnGoingList']),
    ...mapActions('PaymentModule', ['requestCancelDonation']),
    async cancelDonation(donation_id){
      Vue.swal({
        title: 'Cancel Donation',
        text: 'Are you sure to cancel the donation?',
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true
      }).then(async (result) => {
        if(result.value) {
          const data = {
            donation_id
          }
          const resp = await this.requestCancelDonation(data);
          if(!!resp){
            await this.requestOnGoingList();
            this.$swal('Cancel Donation', 'Cancel donation success.', 'success')
          }else{
            this.$swal('Something Wrong. Please Try Again', '', 'error')
          }
        }
      });
    },
  },
}
</script>

<style>
  .custom-image-slider{
    width:100%;
    height: auto;
    object-fit: cover;
  }
  .box-total-donation{
    width: 100%;
    min-height: 300px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.9);
    border-radius: 5px;
    padding:45px 18px;
  }
  .box-total-donation h3{
    font-family: 'Oswald',sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    color: #224181;
    border-bottom: 5px solid #224181;
    padding-bottom: 12px;
    text-align: left;
  }
  .box-total-donation h2.donation-dollar{
    font-family: 'Oswald',sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 53px;
    color: #224181;
    text-align: left;
  }
  .box-total-donation .is-donate{
    font-family: 'Oswald',sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    color: #111111;
  }
  .donation-list-item{
    max-width: 602px;
  }

  .donation-list-item p {
      white-space: pre-line;
  }

  .donation-list-item img{
    width: 100% !important;
    height: auto !important;
    object-fit: cover;
  }

  @media (max-width: 1200px){
    .box-total-donation{
      max-width: 602px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/DonationLists.vue